export default "/_next/static/media/enjoei-advancedcategory2-1024x384.b255c1e0accbf5a6b5171c28210b7c8d.png";